import { ElementType } from "../../library-js/dom-tools/ElementType";
import { ElementContainer } from "../../library-js/dom-tools/ElementContainer";
import { ContextMenu } from "./ContextMenu";
import { ClassFlag } from "../../library-js/dom-tools/ClassFlag";

export abstract class ContextMenuItem extends ElementContainer<HTMLElement>
{
  static readonly flag = new ClassFlag( "context--menu--item" );

  protected _parent:ContextMenu;

  constructor( parent:ContextMenu )
  {
    super();
    this._parent = parent;
    
  }

  abstract _create():void;
  create():void
  {
    this._create();
    ContextMenuItem.flag.set( this.element );
  }
}